import { getVariantEnvironment } from "owa-metatags/lib/getPhysicalRing";

// Per-cloud TrouterConfig defaults for Calendar notifications. Bootstrap applies
// these via overrideDefaultApplicationSettings BEFORE initializeApplicationSettings
// so that ECS (when configured) overlays cloud-correct defaults. URLs are
// owner-vetted; see PR 242774 description for screenshots.

type TrouterConfigDefaults = Record<string, unknown> & {
    TrouterServiceUrl: string;
    RegistrarServiceUrl: string;
    Ic3Resource: string;
};

const WW_DEFAULTS: TrouterConfigDefaults = {
    TrouterServiceUrl: "https://go.trouter.teams.microsoft.com/",
    RegistrarServiceUrl: "https://teams.microsoft.com/registrar/prod/",
    Ic3Resource: "https://ic3.teams.office.com",
};

const GCCH_DEFAULTS: TrouterConfigDefaults = {
    TrouterServiceUrl: "https://go.trouter.gov.teams.microsoft.us/",
    RegistrarServiceUrl: "https://gov.teams.microsoft.us/registrar/",
    Ic3Resource: "https://ic3.gov.teams.microsoft.us",
};

const GCCM_DEFAULTS: TrouterConfigDefaults = {
    TrouterServiceUrl: "https://go.trouter.gcc.teams.microsoft.com/",
    RegistrarServiceUrl: "https://teams.microsoft.com/registrar/prod/",
    Ic3Resource: "https://ic3.teams.office.com",
};

const DOD_DEFAULTS: TrouterConfigDefaults = {
    TrouterServiceUrl: "https://go.trouter.dod.teams.microsoft.us/",
    RegistrarServiceUrl: "https://dod.teams.microsoft.us/registrar/",
    Ic3Resource: "https://ic3.dod.teams.microsoft.us",
};

export function getTrouterConfigDefaults(): TrouterConfigDefaults {
    switch (getVariantEnvironment()) {
        case "GccHigh":
            return GCCH_DEFAULTS;
        case "GCCModerate":
            return GCCM_DEFAULTS;
        case "DoD":
            return DOD_DEFAULTS;
        default:
            return WW_DEFAULTS;
    }
}
